import { tooltipClasses, type Components } from '@mui/material';
import { darkBlue } from '../colors';
import { themeVars } from '../themeVars';
import { typographyStyles, type Theme } from './utils';

export const MuiTooltip: Components<Theme>['MuiTooltip'] = {
  styleOverrides: {
    tooltip: ({ theme }) => ({
      ...typographyStyles(theme.typography.label2),
      // Adjust based on line height
      paddingBlock: `calc(${theme.spacing(1)} - 3px)`,
      paddingInline: theme.spacing(1),
      '--mds-Tooltip-bg': darkBlue[90],
      ...theme.applyStyles('dark', {
        '--mds-Tooltip-bg': darkBlue[10],
      }),
      color: themeVars(theme).palette.text.contrast,
      background: 'var(--mds-Tooltip-bg)',
      [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
        marginBottom: '8px',
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="bottom"] &`]: {
        marginTop: '8px',
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="left"] &`]: {
        marginRight: '8px',
      },
      [`.${tooltipClasses.popper}[data-popper-placement*="right"] &`]: {
        marginLeft: '8px',
      },
    }),
    arrow: {
      color: 'var(--mds-Tooltip-bg)',
      [`.${tooltipClasses.popper}[data-popper-placement*="top"] &`]: {
        // Override to fix a glitch where a gap briefly appears between the tooltip and
        // the arrow
        marginBottom: '-0.7em',
      },
    },
  },
};
